import React from 'react'
import { graphql } from 'gatsby'
import Breadcrumb from "../components/breadcrumb"
import styled from 'styled-components'
import Layout from "../components/layout"
import { Container, Row, Col } from 'reactstrap'
import Image from "gatsby-image"
import Link from '../components/link'
import Box from '../components/box'
import useSiteMetadata from '../hooks/use-site-config'
import { Helmet } from "react-helmet";


const ProcedureImage = styled(Image)`
  border-radius: 10px;
  max-width: 200px;
  margin-top: 20px;
  display: block;
  margin-left: auto;
  margin-right: auto;
`
const BoxWrapper = styled(Box)`
text-align: center !important;
height: unset;
padding-left: unset;
border-left: 0px;
`


export const query = graphql`
query ProcedureQuery($slug: String!) {
  markdownRemark(fields: { slug: { eq: $slug } }) {
    html
    frontmatter {
      title
      description
      noLink
      requisitos
      shift
    }
  }
  allMarkdownRemark {
    edges {
      node {
        fields{
          slug
        }
        frontmatter {
          type
          title
          childrenPath
          order
          fatherPath
          linkGetShifts
          linkLookShifts
          shift
        }
      }
    }
  }
}
`;

export default function Procedure(props) {
  const { siteTitle, getShiftLink } = useSiteMetadata()
  const procedure = props.data.markdownRemark;
  const contentList = props.data.allMarkdownRemark;
  const shiftFilter = contentList.edges.filter(edge => edge.node.frontmatter.childrenPath === "/shift/")[0];
  const { title, noLink, requisitos, acta } = procedure.frontmatter;
  let reque = true;
  if (requisitos === false) {
    reque = false;
  }
  const ti = title + " | " + siteTitle
  return (
    <Layout postList={contentList} here={"/tramites/"}>
      <Helmet title={ti}>
        <meta charSet="utf-8" />
      </Helmet>
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col sm="12" md={{ size: 8 }}>
            <h1 className="display-4">{title}</h1>
            {reque && !noLink && <h2>Requisitos</h2>
            }
            <div dangerouslySetInnerHTML={{ __html: procedure.html }} />
            {title !== "Defunciones" && shiftFilter.node.frontmatter.shift &&
              <h3><a style={{ color: '#C65EA8' }} href={getShiftLink}>Solicitar Turno</a></h3>
            }

          </Col>
        </Row>

     
      </Container>

      <Breadcrumb pageContext={props.pageContext} label={title} />
    </Layout>
  );
}